export var BadgeOverrides = function (theme) { return ({
    MuiBadge: {
        badge: {
            // Background color is set in the main component
            color: theme.palette.brand.contrastText,
            fontWeight: theme.typography.fontWeightSemiBold,
        },
        dot: {
            // Position is set in the main component
            borderRadius: '50%',
        },
    },
}); };
//# sourceMappingURL=Badge.overrides.js.map